import React, { useState } from 'react';
import './App.css';
import heroImg from './hero-image.png';
import navLogo from './navbar-logo.png';

const translations = {
  es: {
    badge: "Actualización en curso",
    title1: "VIA EXPRESS",
    title2: "EN MANTENIMIENTO",
    subtitle: "Trabajamos para mejorar!\n¡Para dudas haz click en soporte y un agente de Via te atenderá enseguida!",
    supportBtn: "Soporte (WhatsApp)",
    contactBtn: "Contacto",
    langToggle: "EN",
  },
  en: {
    badge: "Update in progress",
    title1: "VIA EXPRESS",
    title2: "UNDER MAINTENANCE",
    subtitle: "We are working to improve and bring you better logistics services.\nFor any questions, click on support and a Via agent will assist you immediately!",
    supportBtn: "Support (WhatsApp)",
    contactBtn: "Contact",
    langToggle: "ES",
  }
};

function App() {
  const [lang, setLang] = useState('es');
  const t = translations[lang];

  const handleSupportClick = (e) => {
    e.preventDefault();
    const waNumber = '442080506653';
    const waMessage = "HOLA! ME GUSTARÍA UN SERVICIO Y CASILLERO!";
    const encodedMessage = encodeURIComponent(waMessage);
    window.open(`https://wa.me/${waNumber}?text=${encodedMessage}`, '_blank');
  };

  const toggleLanguage = () => {
    setLang(lang === 'es' ? 'en' : 'es');
  };

  return (
    <>
      <div className="background" />

      <nav className="navbar">
        <div className="nav-content">
          <div className="nav-logo">
            <img src={navLogo} alt="Via Express" />
          </div>
          <div className="nav-actions">
            <button className="nav-btn-lang" onClick={toggleLanguage}>
              {t.langToggle}
            </button>
            <button className="nav-btn-contact" onClick={handleSupportClick}>
              {t.contactBtn}
            </button>
          </div>
        </div>
      </nav>

      <div className="maintenance-container">

        <div className="image-container">
          <img src={heroImg} alt="Logística y Envíos - Mantenimiento" className="hero-image" />
        </div>

        <div className="content-container">
          <div className="badge">{t.badge}</div>

          <h1 className="title">
            {t.title1} <br /><span>{t.title2}</span>
          </h1>

          <p className="subtitle">
            {t.subtitle.split('\n').map((line, i) => (
              <React.Fragment key={i}>
                {line}
                <br />
              </React.Fragment>
            ))}
          </p>

          <a href="#" onClick={handleSupportClick} className="support-btn">
            <svg className="whatsapp-icon" fill="currentColor" viewBox="0 0 24 24">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
            </svg>
            {t.supportBtn}
          </a>
        </div>
      </div>
    </>
  );
}

export default App;
